import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import ggOrder, { OrderComponentSummary } from 'ggApp/modules/order';
import ggAuth from 'ggApp/modules/auth';
import ggRouter from 'ggApp/modules/router';
import ggAddress, {
    AddressForm_Create as CreateAddressForm,
    withCountriesList,
    ADDRESS_TYPE,
} from 'ggApp/modules/address';
import {
    LayoutComponent_Grid_Col as Col,
    LayoutComponent_Grid_Row as Row,
    LayoutComponent_Container as LayoutComponentContainer,
    LayoutComponent_Checkout_Title as LayoutComponentCheckoutTitle,
    LayoutComponent_Checkout_ContentWrap as LayoutComponentCheckoutContentWrap,
    LayoutComponent_Text as LayoutComponentText,
} from 'ggApp/modules/layout';
import ggStore from 'ggApp/modules/store';
import { CheckoutBackToCartLink } from 'ggApp/modules/checkout/components';
import { Translator } from 'ggApp/modules/translator';

const CreateAddressFormWithCountries = withCountriesList(CreateAddressForm);

@connect(
    createStructuredSelector({
        user: ggAuth.selectors.user,
        activeStore: ggStore.selectors.storeActive,
        order: ggOrder.selectors.orderActive,
        authFetching: ggAuth.selectors.fetching,
        phonePrefixes: ggStore.selectors.phonePrefixes,
        authPhoneVerification: ggAuth.selectors.phoneVerification,
    }),
    (dispatch) => ({
        routerActions: bindActionCreators(ggRouter.actions, dispatch),
        authActions: bindActionCreators(ggAuth.actions, dispatch),
        orderActions: bindActionCreators(ggOrder.actions, dispatch),
    }),
)
export default class CheckoutCreateAddress extends Component {
    render() {
        const { authActions, routerActions, orderActions } = this.props;
        const {
            user,
            order,
            phonePrefixes,
            authFetching,
            authPhoneVerification,
            activeStore,
        } = this.props;

        const userNumberPrefix = ggAuth.helpers.detectUserNumberPrefix(user, phonePrefixes);

        return (
            <section>
                <LayoutComponentCheckoutTitle tk="CART_ADDRESS_SHIPPING_TITLE" />
                <LayoutComponentContainer>
                    <LayoutComponentText mini lightWeight>
                        <Translator tk="CART_ADDRESS_SHIPPING_NOTE" />
                    </LayoutComponentText>
                    <LayoutComponentCheckoutContentWrap>
                        <Row cols={[1, 1]}>
                            <Col desktop={40}>
                                <OrderComponentSummary order={order} hideMobile desktopColumnItem />
                                <CheckoutBackToCartLink />
                            </Col>
                            <Col desktop={60}>
                                <CreateAddressFormWithCountries
                                    addressType={ADDRESS_TYPE.SHIPPING}
                                    onSubmitSuccess={(result) => {
                                        const lastAddress = result.sort((a, b) => b.id - a.id)[0];

                                        orderActions.updateOrder({
                                            shipping_address_id: lastAddress.id,
                                        });
                                        orderActions.updateOrderAddress(
                                            order.number,
                                            lastAddress.id,
                                            ggAddress.constants.SHIPPING_NAME,
                                        );

                                        setTimeout(() => {
                                            routerActions.replaceTo('/checkout/payment');
                                        });
                                    }}
                                    updatePhone={authActions.updatePhone}
                                    confirmPhone={authActions.confirmPhone}
                                    authPhoneVerification={authPhoneVerification}
                                    authFetching={authFetching}
                                    initialValues={{
                                        country_id: activeStore && activeStore.country_id,
                                        phone: {
                                            code: userNumberPrefix.prefix || phonePrefixes[0].id,
                                            number: userNumberPrefix.number,
                                            isVerified: user.phone_verified,
                                        },
                                    }}
                                />
                            </Col>
                        </Row>
                    </LayoutComponentCheckoutContentWrap>
                </LayoutComponentContainer>
            </section>
        );
    }
}
